import styled from "styled-components/macro";
import { COLORES } from "../../constants";

export const Wrapper = styled.div`
  position: fixed;
  background-color: ${COLORES.LOADING_BACKGROUND};
  z-index: 100;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;  
  display: flex;  
  justify-content: center;
  align-items: center;
`;

export const Content = styled.div`
  font-size: 0.85rem;
  background-color: ${COLORES.BACKGROUND};
  border-radius: 0.25rem;
  width: auto;
  max-width: 90%;
  max-height: 90%;
  display: flex;
  flex-direction: column;

  animation: BounceEffect 0.15s linear forwards;
  @keyframes BounceEffect {
    0% {
      transform: scale(0);
    }
    50% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(1);
    }
  }
`;

export const Header = styled.div`
  background-color:  ${COLORES.MODAL_TITLE_BG};
  color: ${COLORES.MODAL_TITLE};                  
  font-weight: 600;                 // semibold
  font-size: 1rem;
  padding: 0.75rem 1rem;            // px-4 py-3
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
  border-bottom: 1px solid ${COLORES.MODAL_TITLE_LINE}; 
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  margin: 2rem 2rem 2rem 2rem;
  overflow-y: auto;

  p.centered {
    text-align: center;
  }

  h2.centered,
  h3.centered {
    text-align: center;
    margin: 0;
    margin-bottom: 2rem;
    padding-bottom: 0.75rem;
  }  

   padding-bottom: 0.75rem;
`;

export const Buttons = styled.div`
  display: flex;
  margin-top: 1.5rem;
  justify-content: center;
  column-gap: 2rem;
`;


export const FixedActionContainer = styled.div`
  margin-top: 2rem;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #ffffff;
  padding: 1rem 1.5rem;
  z-index: 1000;
  border-top: 1px solid ${COLORES.MODAL_TITLE_LINE};
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  padding-right: 2rem;
`;